// import styles from "./style.module.scss";
import React, { useEffect, useState } from 'react';
import { img_logo } from '../../assets';
import { Link, useLocation } from 'react-router-dom';
import { HEADER_LINKS, LOCALSTORAGE_TOKEN_LABEL } from '../../constants';
import { useAppContext } from '../../context';
import { Offcanvas } from 'react-bootstrap';

// main header
export default function MainHeader() {
  const [currentTabInd, setCurrentTabInd] = useState(0);
  const location = useLocation();
  const { setUser } = useAppContext();
  const [showMobileNav, setShowMobileNav] = useState(true);

  useEffect(() => {
    setShowMobileNav(false);
    const currentTabInd = HEADER_LINKS.findIndex(
      (link) => link.path === location.pathname
    );
    setCurrentTabInd(currentTabInd);
  }, [location]);

  return (
    <div className='container pt-3 pb-2'>
      <div className={'shadow-sm mb-2 bg-white px-2 py-1 rounded-pill'}>
        <div className="container py-2">
          <div className="row align-items-center">
            <div className="col-8 col-md-4">
              <img src={img_logo} alt="" className="img-fluid" width={110} />
            </div>
            <div
              className={
                'd-none d-md-flex col-8 justify-content-end' +
                ' align-items-center gap-3'
              }
            >
              {HEADER_LINKS.map((i, index) => (
                <div
                  key={index}
                  className={
                    'border-bottom p-1 ' +
                    (currentTabInd === index ? 'fw-bold' : '')
                  }
                >
                  <Link to={i.path}>{i.label}</Link>
                </div>
              ))}
              <button
                className="btn btn-light border border-dark ms-3"
                onClick={() => {
                  window.localStorage.removeItem(LOCALSTORAGE_TOKEN_LABEL);
                  setUser(null);
                }}
              >
                Logout <i className="bi bi-box-arrow-right ms-2"></i>
              </button>
            </div>
            <div
              className={
                'd-flex d-md-none col-4 justify-content-end ' +
                'align-items-center pe-3'
              }
            >
              <button className="btn p-1" onClick={() => setShowMobileNav(true)}>
                <i className="bi bi-list fs-1"></i>
              </button>
            </div>

            <Offcanvas
              show={showMobileNav}
              onHide={() => {
                setShowMobileNav(false);
              }}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                  <img src={img_logo} alt="" className="img-fluid" width={110} />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div
                  className={
                    'd-flex flex-column gap-3 justify-content-start' +
                    ' align-items-center pt-3 fs-5'
                  }
                >
                  {HEADER_LINKS.map((i, index) => (
                    <div
                      key={index}
                      className={
                        'border-bottom p-1 ' +
                        (currentTabInd === index ? 'fw-bold' : '')
                      }
                    >
                      <Link to={i.path}>{i.label}</Link>
                    </div>
                  ))}
                  <button
                    className="btn border-bottom p-1 fs-5"
                    onClick={() => {
                      window.localStorage.removeItem(LOCALSTORAGE_TOKEN_LABEL);
                      setUser(null);
                    }}
                  >
                    Logout <i className="bi bi-box-arrow-right ms-2"></i>
                  </button>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </div>
    </div>
  );
}
